import { ChangeDetectorRef } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';

export const MANUAL_FORM_MRN_MIN_LENGTH = 3;
export const MANUAL_FORM_MRN_MAX_LENGTH = 30;
export const MANUAL_FORM_MRN_PATTERN = /^[a-zA-Z0-9]*$/;

export const MANUAL_FORM_MRN_VALIDATORS: ValidatorFn[] = [
  Validators.required,
  Validators.minLength(MANUAL_FORM_MRN_MIN_LENGTH),
  Validators.maxLength(MANUAL_FORM_MRN_MAX_LENGTH),
  Validators.pattern(MANUAL_FORM_MRN_PATTERN),
];

export interface ManualSurveyFormControls {
  mrn: FormControl<string>;
  joints: FormControl<string>;
  category: FormControl<string>;
  physician: FormControl<string>;
}

export function createManualSurveyFormGroup(): FormGroup<ManualSurveyFormControls> {
  return new FormGroup<ManualSurveyFormControls>({
    mrn: new FormControl<string>('', {
      nonNullable: true,
      validators: MANUAL_FORM_MRN_VALIDATORS,
    }),
    joints: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    category: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    physician: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
  });
}

/** Invalid and touched — show inline error (native fields, no mat-error). */
export function manualFormShowFieldError(control: AbstractControl | null): boolean {
  return Boolean(control?.invalid && control.touched);
}

export function manualFormOnMrnBlur(form: FormGroup, cdr: ChangeDetectorRef): void {
  form.get('mrn')?.markAsTouched();
  form.get('mrn')?.updateValueAndValidity({ emitEvent: false });
  setTimeout(() => cdr.markForCheck(), 0);
}
